import React from 'react';
import PropTypes from 'prop-types';

import Header from 'components/Header';
import Footer from 'components/Footer';
import SiteHead from 'components/Head';

import 'style/global.scss';


const TemplateWrapper = ({children}) => (
    <React.Fragment>
        <SiteHead />

        <Header />
        <div>
            {children()}
        </div>
        <Footer/>
    </React.Fragment>
);

TemplateWrapper.propTypes = {
    children: PropTypes.func,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js